/**
 * Globálny formát dátumu – display a filter.
 * Formáty z UnitsSettings: dd.MM.yyyy, dd/MM/yyyy, yyyy-MM-dd, MM/dd/yyyy, d. M. yyyy
 * Luxon používa rovnaké tokeny.
 *
 * Phase 2: legacy signature preserved. Prefer formatters.formatDate / formatDateTime
 * when timezone or empty-display control is needed.
 */
import { DateTime } from 'luxon';
import { getDateFormat as getDateFormatFromSettings } from './moduleSettings';
import {
  DEFAULT_DATE_FORMAT,
  TIME_FORMAT,
  formatDate as formatDateCanonical,
  formatDateTime as formatDateTimeCanonical,
  formatTime as formatTimeCanonical,
} from './formatters';

/** Vráti globálny formát z module_settings */
export function getDateFormat(moduleSettings) {
  return getDateFormatFromSettings(moduleSettings) || DEFAULT_DATE_FORMAT;
}

/**
 * Formátuje dátum (ISO/SQL string) podľa formátu.
 * Legacy signature: formatDate(value, format, withTime)
 * @param {string} value - ISO alebo SQL datetime string
 * @param {string} [format] - Luxon format, default dd.MM.yyyy
 * @param {boolean} [withTime=false] - pridať HH:mm
 */
export function formatDate(value, format = DEFAULT_DATE_FORMAT, withTime = false) {
  // Guard: callers sometimes pass dateFormat that already includes HH:mm
  let dateFormat = format || DEFAULT_DATE_FORMAT;
  let useTime = withTime;
  if (typeof dateFormat === 'string' && /\sHH:mm\b/.test(dateFormat)) {
    dateFormat = dateFormat.replace(/\sHH:mm\b/, '').trim() || DEFAULT_DATE_FORMAT;
    useTime = true;
  }
  return formatDateCanonical(value, { dateFormat, withTime: useTime, empty: '' });
}

/** Formát pre datetime (dátum + čas) */
export function getDateTimeFormat(moduleSettings) {
  return `${getDateFormat(moduleSettings)} ${TIME_FORMAT}`;
}

export function formatDateTime(value, format = DEFAULT_DATE_FORMAT, timezone = null) {
  return formatDateTimeCanonical(value, { dateFormat: format, timezone, empty: '' });
}

export function formatTime(value, timezone = null) {
  return formatTimeCanonical(value, { timezone, empty: '' });
}

/** @deprecated Prefer formatters; kept for call sites that need Luxon. */
export function parseApiDateTime(value) {
  if (value == null || value === '') return null;
  const raw = String(value).trim();
  if (!raw) return null;
  let dt = DateTime.fromISO(raw, { setZone: true });
  if (dt.isValid) return dt;
  dt = DateTime.fromSQL(raw, { setZone: true });
  if (dt.isValid) return dt;
  if (raw.includes(' ') && !raw.includes('T')) {
    dt = DateTime.fromISO(raw.replace(' ', 'T'), { setZone: true });
    if (dt.isValid) return dt;
  }
  return null;
}
